import { HomeDashboardContainer } from "../../../containers";

export const DashboardIndexPage = () => {
  return <HomeDashboardContainer />;
};
